
export enum EsSignatureValueTypeEnum {
  PngBase64
}
